import { storeData } from './CheckoutPageSessionHelpers';
import { setInitialValues as checkoutReducerSetInitialValues } from './CheckoutPage.duck';

const STORAGE_KEY = 'CheckoutPage';

/**
 * Igual que el método estático CheckoutPage.setInitialValues: actualiza Redux y,
 * si aplica, persiste en sessionStorage para el flujo invitado → registro → checkout.
 */
export const checkoutSetInitialValues = (initialValues, saveToSessionStorage = false) => {
  if (saveToSessionStorage && typeof window !== 'undefined') {
    const { listing, orderData } = initialValues;
    storeData(orderData, listing, null, STORAGE_KEY);
  }

  return checkoutReducerSetInitialValues(initialValues);
};
